export default "__VITE_PUBLIC_ASSET__cdd5ae52__"